import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { QrCodeService, QrSessionDto } from '@artemis-software/wr-api';
import { ContractorCredentialsService } from '@services/contractor-credentials.service';

@Injectable({ providedIn: 'root' })
export class QrSessionService {
  private readonly qrCodeService = inject(QrCodeService);
  private readonly credentialsService = inject(ContractorCredentialsService);

  private cached?: { key: string; session: Promise<QrSessionDto> };

  session(): Promise<QrSessionDto> {
    const key = `${this.credentialsService.getCurrentShortCode()}|${this.credentialsService.getCurrentPin()}`;
    if (this.cached?.key !== key) {
      const session = firstValueFrom(this.qrCodeService.findSession());
      session.catch(() => this.cached = undefined);
      this.cached = { key, session };
    }
    return this.cached.session;
  }

  async isExternalUser(): Promise<boolean> {
    const session = await this.session();
    return session.kind === QrSessionDto.KindEnum.ExternalUser;
  }
}
